module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_cacahuate_horneado.ffd3bce5.png";